var PES = PES || {};

//this is not refactored yet
//it will be extracted into seperate files when each step is gonna be implemented
PES.CheckoutValidation = function () {

    function loginOrRegister(checkoutViewModel, callbackFunction, callbackParam) {
        callbackFunction(callbackParam);
    }

    function paymentInformation(checkoutViewModel, callbackFunction, callbackParam) {
        callbackFunction(callbackParam);
    }

    return {
        loginOrRegister: loginOrRegister,
        paymentInformation: paymentInformation
    }
}();